// Component Mine/Item
<template lang="html">
  <div class="item" @click="toTimetable">
    <div class="item-avatar">
      <img :src="(course && course.image) || avatarHolder" alt="itemAvatar"/>
      <div class="item-avatar-progress">{{`已学习${ fixedNumber(course.learnPercent * 100, 0) }%`}}</div>
    </div>

    <div class="item-desc">
      <h3>{{ course.title | titleCut}}</h3>
      <p v-if="course.resource" @click="showUrl(course.resource)" class="item-desc-coursewave"><i></i>下载课件</p>
      <h5 v-if="course.buyFrom !== 8">{{!course.validDays || course.validDays == '' || course.validDays == null ? '永久有效' : `${course.validDays}天有效期`}}</h5>
      <template v-else>
        <h5 v-if="isExpired">已失效</h5>
        <h5 v-else>过期时间：{{ course.expireDate | formatTimestampToDate('YYYY-MM-DD') }}</h5>
      </template>
      <div class="item-desc-buttonGroup">
        <!-- <button id="live">看直播</button> -->
        <button v-if="isExpired" id="expired" @click.stop="pay">立即+订阅</button>
        <button v-else id="sheet">立即学习</button>
      </div>
    </div>
  </div>
</template>

<script>
import avatarHolder from './.default/avatar.png'
import formatTimestampToDate from '../../filters/format-timestamp-to-date'
import fixedNumber from '../../filters/fixed-number'
import module from '../../modules/today'
import { mapState, mapActions } from 'vuex'
import Cookie from 'js-cookie'
export default {
  name: 'MineItem',
  props: ['course', 'courseIndex'],

  filters: {
    formatTimestampToDate,
    fixedNumber,
    titleCut (val) {
      return val.length > 12 ? `${val.slice(0, 12)}...` : val
    }
  },

  computed: {
    isExpired () {
      return this.course.expireDate < new Date().getTime()
    },
    ...mapState({
      courseList: (state) => state[module.name].courseList
    })
  },

  data () {
    return {
      avatarHolder: avatarHolder
    }
  },

  methods: {
    ...mapActions(['today/deleteCourse']),
    toTimetable () {
      if (this.course.type === 8) {
        this.wxQrCode()
      } else {
        this.$router.push({
          name: 'schedule',
          query: { courseId: this.course.id }
        })
      }
    },

    deleteCourse () {
      this['today/deleteCourse'](this.courseIndex)
    },

    pay () {
      this.$router.push({
        name: 'sign-up',
        query: { courseId: this.course.id }
      })
    },

    showUrl (url) {
      this.$emit('showNotice', url)
    },
    async wxQrCode () {
      this.$axios
        .get(
          `https://course.auoktalk.com/api/platform/user/mic/program/qr/code?userId=${Cookie.get(
            'openid'
          )}&courseId=${this.course.id}&micProgramAppId=${this.$route.query.micProgramAppId || ''}`
        )
        .then((res) => {
          const {
            data: { data = '' }
          } = res
          if (data == '') {
            return this.$toast.show({
              message: res.data.msg
            })
          }
          sessionStorage.setItem('qrCodeImage', data)
          this.$router.push('wx-service')
        })
    },

    fixedNumber
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";
$global-width: 750;
.item {
  position: relative;
  height: rem(250);
  width: rem(690);
  padding: rem(30) 0;
  box-sizing: border-box;
  /*border-radius: rem(8);*/
  background-color: #fff;
  margin: auto;
  /*box-shadow: 0 rem(5) rem(10) rgba(0, 0, 0, .2);*/
  &-avatar {
    position: relative;
    float: left;
    height: rem(190);
    width: rem(155);
    border-radius: rem(8);
    overflow: hidden;
    margin-right: rem(30);
    img {
      height: 100%;
    }
    &-progress {
      position: absolute;
      bottom: 0;
      left: 0;
      height: rem(36);
      width: 100%;
      color: #fff;
      font-size: rem(22);
      line-height: rem(36);
      text-align: center;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  &-desc {
    position: relative;
    float: left;
    height: rem(190);
    width: rem(500);
    &-del {
      width: rem(128);
      position: absolute;
      right: 0;
      top: rem(4);
      > img {
        width: 100%;
      }
    }
    &-coursewave {
      i {
        display: inline-block;
        height: rem(23);
        width: rem(20);
        vertical-align: middle;
        background: url("../../assets/icons/mine-icon-download.png") no-repeat;
        background-size: 100% 100%;
        margin-right: use(8);
        transform: translateY(use(-2));
      }
      /* 下载课件: */
      font-size: use(24);
      color: #f48f00;
    }
    h3 {
      color: #333;
      font-size: rem(28);
      line-height: rem(32);
      margin-bottom: rem(20);
      i {
        display: inline-block;
        height: rem(30);
        width: rem(80);
        margin-left: rem(10);
        color: #f4484c;
        font-size: rem(18);
        line-height: rem(26);
        text-align: center;
        box-sizing: border-box;
        border: rem(2) solid #f4484c;
        border-radius: rem(2);
      }
    }
    h5 {
      color: #999;
      font-size: rem(22);
      position: absolute;
      bottom: 0;
      left: 0;
    }
    &-buttonGroup {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      height: rem(50);
      button {
        float: right;
        height: rem(50);
        width: rem(140);
        margin-left: rem(20);
        color: $globalColor;
        font-size: rem(24);
        line-height: rem(46);
        box-sizing: border-box;
        border: rem(2) solid $globalColor;
        border-radius: rem(6);
        outline: 0;
        background-color: #fff;
      }
      #live,
      #expired {
        color: #fff;
        background-color: #f48f00;
      }
    }
  }
}
</style>
